import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { CustomFieldDefinitionCollection } from '../index'

export const setupCustomFieldDefinitionReplication = (
  collection: CustomFieldDefinitionCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'customfielddefinitions',
    displayName: 'CustomFieldDefinition',
    collection,
    envId,
    apiEntityName: 'custom-field-definitions',
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      name: doc.name,
      fieldType: doc.fieldType,
      sortOrder: doc.sortOrder ?? null,
      isRequired: doc.isRequired || false,
      customFieldTabId: doc.customFieldTabId,
      customFieldGroupId: doc.customFieldGroupId ?? null,
      config: doc.config || null,
      workItemTypeIds: doc.workItemTypeIds || [],
      projectIds: doc.projectIds || [],
      options: doc.options || null,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      name: state.name,
      fieldType: state.fieldType,
      sortOrder: state.sortOrder,
      isRequired: state.isRequired,
      customFieldTabId: state.customFieldTabId,
      customFieldGroupId: state.customFieldGroupId ?? null,
      config: state.config,
      workItemTypeIds: state.workItemTypeIds,
      projectIds: state.projectIds,
      options: state.options,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
